import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./accordion.module.css";
const AccordionContent = ({ isExpanded , id , content , sectionId , buttonId  })=>{
    const [height, setHeight] = useState(0);
    const [display, setDisplay] = useState("none");
    const innerContainerRef = useRef(null);
    useEffect(()=>{
        const handleResize = ()=>{
            if (height > 0) {
                onEntered();
            }
        };
        window.addEventListener("resize", handleResize, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        height
    ]);
    const onEntering = ()=>{
        setDisplay("block");
    };
    const onEntered = ()=>{
        if (innerContainerRef.current) {
            setHeight(innerContainerRef.current.offsetHeight);
        }
    };
    const onExiting = ()=>{
        setHeight(0);
    };
    const onExit = ()=>{
        setDisplay("none");
    };
    return /*#__PURE__*/ _jsx(CSSTransition, {
        in: isExpanded,
        timeout: 200,
        onEntering: onEntering,
        onEntered: onEntered,
        onExiting: onExiting,
        onExit: onExit,
        "aria-hidden": !isExpanded,
        role: "region",
        id: `${sectionId}-${id}`,
        "aria-labelledby": `${buttonId}-${id}`,
        "data-testid": `${sectionId}-${id}`,
        className: classnames(styles.accordionContentContainer),
        style: {
            height
        },
        children: /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("div", {
                ref: innerContainerRef,
                style: {
                    display
                },
                className: classnames(styles.accordionContentInnerContainer),
                children: content()
            })
        })
    });
};
export default AccordionContent;
